import { useAtomValue } from 'jotai';
import { moveTaskOrderAtom } from '@/store/moveTaskOrderAtom';

export const useMoveTaskOrderOrders = () => {
  const mto = useAtomValue(moveTaskOrderAtom);
  return mto.orders;
};
